import React, { ChangeEvent } from 'react';
import { Checkbox, Form, Typography, Col, Space } from 'antd';
import { FieldConfig } from '../../types/fieldTypes';
import { useValidator } from '../../hooks/useValidator';

const { Text } = Typography;

interface CheckboxFieldProps {
  field: FieldConfig;
  value: any;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  mode: 'edit' | 'view';
  formData?: Record<string, any>;
}

export const CheckboxField: React.FC<CheckboxFieldProps> = ({
  field,
  value,
  onChange,
  mode,
  formData = {},
}) => {
  const { touched, validationError, handleValidate } = useValidator({
    field,
    value,
    formData,
  });

  const handleChange = (checked: boolean) => {
    const syntheticEvent = {
      target: {
        name: field.name,
        value: checked,
        type: 'checkbox',
      },
    } as unknown as ChangeEvent<HTMLInputElement>;

    onChange(syntheticEvent);
    handleValidate(checked);
  };

  if (mode === 'view') {
    return (
      <Col span={field.layout?.span || 24}>
        <Form.Item label={<Text type="secondary">{field.label}</Text>}>
          <Text type="secondary">{value ? 'Yes' : 'No'}</Text>
        </Form.Item>
      </Col>
    );
  }

  const colProps = {
    span: field.layout?.span || 24,
    offset: field.layout?.offset || 0,
    order: field.layout?.order,
  };

  return (
    <Col {...colProps} className={field.layout?.className}>
      <Form.Item
        validateStatus={validationError && touched ? 'error' : ''}
        help={
          <Space direction="vertical" size="small">
            {field.customProps?.helpText && (
              <Text type="secondary">{field.customProps.helpText}</Text>
            )}
            {validationError && touched && (
              <Text type="danger">{validationError}</Text>
            )}
          </Space>
        }
      >
        <Checkbox
          name={field.name}
          checked={!!value}
          onChange={e => handleChange(e.target.checked)}
          disabled={field.customProps?.disabled}
        >
          <Space>
            {field.label}
            {field.required && <Text type="danger">*</Text>}
          </Space>
        </Checkbox>
      </Form.Item>
    </Col>
  );
};
